import { isNotFoundError } from "./orpcErrors.ts";

export function retryUnlessNotFound(failureCount: number, error: Error) {
    return !isNotFoundError(error) && failureCount < 3;
}
